import { render, staticRenderFns } from "./ASLFeedback.vue?vue&type=template&id=368176b1&scoped=true"
import script from "./ASLFeedback.vue?vue&type=script&lang=js"
export * from "./ASLFeedback.vue?vue&type=script&lang=js"
import style0 from "./ASLFeedback.vue?vue&type=style&index=0&id=368176b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368176b1",
  null
  
)

export default component.exports